import React from 'react';
import {FormattedMessage} from 'react-intl';
import CustomScrollDiv from '../../../forecast-app/shared/components/scroll-bars/custom_scroll_div';
import InformationIcon from '../../../images/information-icon';
import MatchGroupCard from './match_group_card';
import {confirmedCount, groupKey} from './resolution_state';

const AutoLinkBanner = ({messageId, count}) => (
	<div className="integration-match-banner">
		<InformationIcon className="integration-match-banner-icon" />
		<FormattedMessage id={messageId} values={{count}} />
	</div>
);

/**
 * An integration's "Review matching clients" step (T4-144; T4-135's step, made provider-neutral). Presentational:
 * the container owns the selection, so BACK can return to the list with the ticks intact. The counter counts cards
 * resolved - the same predicate as the card badge - not records to import. Its QuickBooks wording, "matches
 * confirmed", is the design's (spec 015).
 *
 * With no groups there is nothing to confirm, so no description, cards or counter: only how many of the selected
 * records will be linked automatically (`messages.autoLinkedOnly`), shown before the import (T4-144 review round 3,
 * Amar's gap 2, AC8).
 */
const MatchReviewStep = ({groups, autoLinkCount, selectedCount, selection, onSelect, provider}) =>
	groups.length === 0 ? (
		<div className="integration-sync-clients-modal-content integration-match-review">
			{autoLinkCount > 0 ? <AutoLinkBanner messageId={provider.messages.autoLinkedOnly} count={autoLinkCount} /> : null}
		</div>
	) : (
		<div className="integration-sync-clients-modal-content integration-match-review">
			<div className="integration-sync-clients-modal-description">
				<FormattedMessage id={provider.messages.description} values={{total: selectedCount}} />
			</div>
			{autoLinkCount > 0 ? <AutoLinkBanner messageId={provider.messages.autoLinked} count={autoLinkCount} /> : null}
			<CustomScrollDiv autoHeight autoHeightMin={10} autoHeightMax={'45vh'}>
				{groups.map(group => (
					<MatchGroupCard
						key={groupKey(group)}
						group={group}
						selection={selection}
						onSelect={onSelect}
						provider={provider}
					/>
				))}
			</CustomScrollDiv>
			<div className="integration-match-confirmed-count">
				<FormattedMessage
					id={provider.messages.confirmedCount}
					values={{confirmed: confirmedCount(groups, selection), total: groups.length}}
				/>
			</div>
		</div>
	);

export default MatchReviewStep;
